import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { PsListTable } from '../../../shared/components/list-table/PsListTable';

export class ContractorListTable extends React.Component {

    render() {
        const {
            data,
            error,
        } = this.props;

        return (
            <PsListTable
                data={data}
                error={error}
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_NIF')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                    </tr>
                )}
            >
                {
                    data.map((contractor) => {
                        return (
                            <tr key={contractor.id()}>
                                <td>{contractor.nif()}</td>
                                <td>{contractor.name()}</td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }

}

ContractorListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
};
ContractorListTable.defaultProps = {
    data: [],
    error: '',
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/list/ContractorListTable.jsx